import moment from 'moment';

class Storage {
  constructor() {
    this.catalogExpiration = 3;
    this.companyExpiration = 72;
    this.orderExpiration = 1;
  }
  set catalog(data) {
    const catalog = data;
    if (data !== null) {
      catalog.expires = moment().add(this.catalogExpiration, 'hours').toISOString();
    }
    localStorage.setItem('catalog', JSON.stringify(catalog));
  }
  get catalog() {
    const data = localStorage.getItem('catalog');
    if (!data) return null;
    try {
      const catalog = JSON.parse(data);
      if (typeof catalog !== 'object' || moment(catalog.expires).isBefore(moment())) return null;
      return catalog;
    } catch (err) {
      return null;
    }
  }
  set company(data) {
    const company = data;
    if (data !== null) {
      company.expires = moment().add(this.companyExpiration, 'hours').toISOString();
    }
    localStorage.setItem('company', JSON.stringify(company));
  }
  get company() {
    const data = localStorage.getItem('company');
    if (!data) return null;
    try {
      const company = JSON.parse(data);
      if (typeof company !== 'object' || moment(company.expires).isBefore(moment())) return null;
      return company;
    } catch (err) {
      return null;
    }
  }
  set order(data) {
    const order = data;
    if (data !== null) {
      order.expires = moment().add(this.orderExpiration, 'hours').toISOString();
    }
    localStorage.setItem('order', JSON.stringify(order));
  }
  get order() {
    const data = localStorage.getItem('order');
    if (!data) return null;
    try {
      const order = JSON.parse(data);
      if (typeof order !== 'object' || moment(order.expires).isBefore(moment())) return null;
      return order;
    } catch (err) {
      return null;
    }
  }
}

/* eslint-disable */
const storage = {
  install(Vue, options) {
    Vue.prototype.$storage = new Storage();
  },
};

export default storage;



// WEBPACK FOOTER //
// ./src/helpers/storage.js